import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MuiAlert from '@material-ui/lab/Alert';
import React, { useState } from 'react';
import { withFirebase } from '../Firebase';
import EachLocation from './eachLocation';
import LocationDrawer from './locationDrawer';

const useStyles = makeStyles((theme) => ({
   root: {
      marginTop: theme.spacing(2),
   },
}));

function Alert(props) {
   return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Locations = (props) => {
   const classes = useStyles();
   const authUser = JSON.parse(localStorage.getItem('authUser'));
   const [locationDrawer, setLocationDrawer] = useState(false);
   const [snackBar, setSnackBar] = useState({
      display: false,
      type: 'success',
      message: '',
   });

   // --- TEMP: Fetch non-archived desks at a specific location ---
   // const [tempDesks, setTempDesks] = useState(null);
   // const [tempLoading, setTempLoading] = useState(false);
   // const [copyMapStatus, setCopyMapStatus] = useState({ running: false, progress: '', done: false, error: '' });
   // const [mapFile, setMapFile] = useState(null);

   // const fetchDesks = async () => {
   //    setTempLoading(true);
   //    try {
   //       const snapshot = await props.firebase
   //          .spaces('SxXPQ8NjY4N9uKFQVQCL')
   //          .where('archive', '==', false)
   //          .get();
   //       const desks = [];
   //       const coalDeskRegex = /^Coal Desk (\d+)$/;
   //       snapshot.forEach((doc) => {
   //          const data = doc.data();
   //          const match = data.name && data.name.match(coalDeskRegex);
   //          if (match) {
   //             const num = parseInt(match[1], 10);
   //             if (num >= 1 && num <= 125) {
   //                desks.push({ id: doc.id, ...data });
   //             }
   //          }
   //       });
   //       setTempDesks(desks);
   //    } catch (err) {
   //       console.error('Error fetching desks:', err);
   //       setTempDesks([]);
   //    }
   //    setTempLoading(false);
   // };

   // const LID = 'SxXPQ8NjY4N9uKFQVQCL';

   // const copyMapToAllDesks = async () => {
   //    if (!tempDesks || tempDesks.length === 0) return;
   //    if (!mapFile) {
   //       setCopyMapStatus({ running: false, progress: '', done: false, error: 'Please select a map image file first.' });
   //       return;
   //    }
   //    setCopyMapStatus({ running: true, progress: 'Starting...', done: false, error: '' });

   //    // Upload a copy to Coal Desks 3–125
   //    const otherDesks = tempDesks.filter((d) => {
   //       const match = d.name && d.name.match(/^Coal Desk (\d+)$/);
   //       if (!match) return false;
   //       const num = parseInt(match[1], 10);
   //       return num >= 3 && num <= 125;
   //    });
   //    let completed = 0;
   //    let errors = [];
   //    for (const desk of otherDesks) {
   //       completed++;
   //       setCopyMapStatus((s) => ({ ...s, progress: `Uploading to ${desk.name} (${completed}/${otherDesks.length})...` }));
   //       try {
   //          const destPath = 'locations/' + LID + '/spaceImages/' + desk.id + '/';
   //          await props.firebase.uploadImage(mapFile, destPath);
   //          // Set mapPath on the desk document
   //          await props.firebase.getSpace(LID, desk.id).set(
   //             { mapPath: destPath + mapFile.name },
   //             { merge: true },
   //          );
   //       } catch (err) {
   //          errors.push(desk.name + ': ' + err.message);
   //       }
   //    }

   //    if (errors.length > 0) {
   //       setCopyMapStatus({ running: false, progress: '', done: true, error: 'Completed with errors: ' + errors.join('; ') });
   //    } else {
   //       setCopyMapStatus({ running: false, progress: '', done: true, error: '' });
   //    }
   // };
   // --- END TEMP ---

   const snackbarClose = (event, reason) => {
      if (reason === 'clickaway') {
         return;
      }
      setSnackBar({ ...snackBar, display: false });
   };

   async function deleteDoc(path) {
      let schedule = await props.firebase.wholeCollection(path + '/schedule').get();
      if (!schedule.empty) {
         // schedule.forEach(doc => {
         //   let docPath = path+"/schedule/"+doc.id;
         //   deleteDoc(docPath);
         // })
      } else {
         await props.firebase.doc(path).delete();
      }
   }
   async function deleteCollection(path) {
      let docs = await props.firebase.wholeCollection(path).get();
      if (!docs.empty) {
         docs.forEach((doc) => {
            let docPath = path + doc.id;
            deleteDoc(docPath);
         });
      }
   }

   async function resetAllData() {
      const authUser = JSON.parse(localStorage.getItem('authUser'));

      let path = `company/${authUser.cid}/people/`;
      deleteCollection(path);
   }

   return (
      <React.Fragment>
         {/* --- TEMP: Desk debug panel --- */}
         {/* <Grid container spacing={2} style={{ padding: 16, marginBottom: 16, background: '#f5f5f5', borderRadius: 8 }}>
            <Grid item xs={12}>
               <Button
                  variant="contained"
                  color="secondary"
                  onClick={fetchDesks}
                  disabled={tempLoading}
               >
                  {tempLoading ? 'Loading...' : 'Fetch Non-Archived Desks (SxXPQ8NjY4N9uKFQVQCL)'}
               </Button>
               {tempDesks && tempDesks.length > 0 && (
                  <>
                     <input
                        accept="image/*"
                        type="file"
                        id="map-file-picker"
                        style={{ display: 'none' }}
                        onChange={(e) => {
                           if (e.target.files && e.target.files[0]) {
                              setMapFile(e.target.files[0]);
                           }
                        }}
                     />
                     <label htmlFor="map-file-picker">
                        <Button
                           variant="outlined"
                           component="span"
                           style={{ marginLeft: 12 }}
                        >
                           {mapFile ? mapFile.name : 'Choose Map Image'}
                        </Button>
                     </label>
                     <Button
                        variant="contained"
                        style={{ marginLeft: 12, backgroundColor: '#e65100', color: '#fff' }}
                        onClick={copyMapToAllDesks}
                        disabled={copyMapStatus.running || !mapFile}
                     >
                        {copyMapStatus.running ? copyMapStatus.progress : 'Copy Map to All Desks'}
                     </Button>
                  </>
               )}
               {copyMapStatus.done && !copyMapStatus.error && (
                  <Typography style={{ marginLeft: 12, color: 'green', fontWeight: 'bold' }}>
                     Done! Map copied to all Coal Desks.
                  </Typography>
               )}
               {copyMapStatus.error && (
                  <Typography style={{ marginLeft: 12, color: 'red', fontWeight: 'bold' }}>
                     {copyMapStatus.error}
                  </Typography>
               )}
            </Grid>
            {tempDesks && (
               <Grid item xs={12}>
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: 8 }}>
                     {tempDesks.length} desk(s) found:
                  </Typography>
                  <TableContainer style={{ maxHeight: 500 }}>
                     <Table size="small" stickyHeader>
                        <TableHead>
                           <TableRow>
                              {tempDesks.length > 0 &&
                                 Object.keys(tempDesks[0]).sort().map((key) => (
                                    <TableCell key={key} style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                                       {key}
                                    </TableCell>
                                 ))}
                           </TableRow>
                        </TableHead>
                        <TableBody>
                           {[...tempDesks]
                              .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                              .map((desk) => (
                                 <TableRow key={desk.id}>
                                    {Object.keys(tempDesks[0]).sort().map((key) => (
                                       <TableCell key={key} style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
                                          {typeof desk[key] === 'object'
                                             ? JSON.stringify(desk[key])
                                             : String(desk[key] ?? '')}
                                       </TableCell>
                                    ))}
                                 </TableRow>
                              ))}
                        </TableBody>
                     </Table>
                  </TableContainer>
               </Grid>
            )}
         </Grid> */}
         {/* --- END TEMP --- */}

         <LocationDrawer
            locationDrawer={locationDrawer}
            company={props.company}
            setLocationDrawer={setLocationDrawer}
            setSnackBar={setSnackBar}
            locations={props.locations}
         />
         <Snackbar
            open={snackBar.display}
            autoHideDuration={6000}
            onClose={snackbarClose}
         >
            <Alert onClose={snackbarClose} severity={snackBar.type}>
               {snackBar.message}
            </Alert>
         </Snackbar>
         <Grid container direction="row" spacing={3} className={classes.root}>
            <Grid item xs={12}>
               <Typography variant="caption">
                  Locations are ways to group your people together. People in a location
                  or area are able to see other people within the area or location, but
                  are not able to see people outside their own area. If you are a company
                  that is fully remote, you will still need to have one area in order to
                  have all the people showing up.
               </Typography>
            </Grid>
            {props.company?.features?.multisite && (
               <Grid container item direction="column" spacing={3}>
                  <Grid item xs={12}>
                     <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => setLocationDrawer(true)}
                     >
                        Add a Location
                     </Button>
                  </Grid>
               </Grid>
            )}
            <Grid container item xs={12}>
               {props.locations.map((location) => (
                  <EachLocation
                     key={location.id}
                     cid={authUser.cid}
                     company={props.company}
                     locations={props.locations}
                     locationKey={location.id}
                     locationName={location.name}
                     setSnackBar={setSnackBar}
                  />
               ))}
            </Grid>
            {props.company?.features?.multisite && props.archivedLocations && (
               <Grid container item xs={12}>
                  {props.archivedLocations.map((archivedLocation) => (
                     <EachLocation
                        key={archivedLocation.id}
                        archived={true}
                        cid={authUser.cid}
                        company={props.company}
                        locations={props.archivedLocations}
                        locationKey={archivedLocation.id}
                        locationName={archivedLocation.name}
                        setSnackBar={setSnackBar}
                     />
                  ))}
               </Grid>
            )}
            {/* <Grid item xs={12}>
            <Button onClick={()=>resetAllData()}>Reset</Button>
          </Grid> */}
         </Grid>
      </React.Fragment>
   );
};
export default withFirebase(Locations);
